// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planocontas_ShowResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Plano Contas Show Response
 *
 * Returns a single conta by ID with enriched variance data
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planocontas_ShowResponseDados {
id: number
fechamento_mensal_id: number
franquia_id: number
categoria_id: number
nome_conta: string
operacao: string
tipo: string
percentual_faturamento: string
valor_previsto: string
valor_efetivo: string
created_at: string
updated_at: string
variacao_percentual: number
variance_status: string
variance_icon: string
}

export type Planocontas_ShowResponse = ApiResponse<Planocontas_ShowResponseDados>;

registerResponseContract('Planocontas_ShowResponse', {
  id:                     { type: 'number',  required: false },
  fechamento_mensal_id:   { type: 'number',  required: false },
  franquia_id:            { type: 'number',  required: false },
  categoria_id:           { type: 'number',  required: false },
  nome_conta:             { type: 'string',  required: true },
  operacao:               { type: 'string',  required: true },
  tipo:                   { type: 'string',  required: true },
  percentual_faturamento: { type: 'string',  required: false },
  valor_previsto:         { type: 'string',  required: true },
  valor_efetivo:          { type: 'string',  required: true },
  created_at:             { type: 'string',  required: false },
  updated_at:             { type: 'string',  required: false },
  variacao_percentual:    { type: 'number',  required: true },
  variance_status:        { type: 'string',  required: true },
  variance_icon:          { type: 'string',  required: true },
})
